<div if.bind="savedSearch.saveSearchOpen" class="modal-overlay" click.trigger="savedSearch.cancelSaveSearch()">
  <form class="login-modal" submit.trigger="savedSearch.saveCurrentSearch()" click.trigger="$event.stopPropagation()">
    <h3 class="login-modal__title">Save search</h3>
    <label class="login-field">
      <span>Name</span>
      <input
        type="text"
        ref="saveSearchInput"
        value.bind="savedSearch.newSearchName"
        placeholder="Name this search…"
        disabled.bind="savedSearch.savingSearch"
        maxlength="128" />
    </label>
    <label if.bind="savedSearch.canNotifyByEmail" class="login-check">
      <input type="checkbox" checked.bind="savedSearch.notifyByEmail" disabled.bind="savedSearch.savingSearch" />
      <span>Receive email notifications</span>
    </label>
    <p if.bind="!savedSearch.canNotifyByEmail" class="save-search__nudge">
      Saved on this device.
      <button type="button" class="save-search__nudge-link" click.trigger="account.signIn()">Create a free account</button>
      to sync it and get email alerts when new releases match.
    </p>
    <div if.bind="savedSearch.savedSearchError" class="login-error">${savedSearch.savedSearchError}</div>
    <div class="login-actions">
      <button type="button" class="login-btn login-btn--secondary" click.trigger="savedSearch.cancelSaveSearch()" disabled.bind="savedSearch.savingSearch">Cancel</button>
      <button type="submit" class="login-btn login-btn--primary" disabled.bind="!savedSearch.newSearchName.trim() || savedSearch.savingSearch">
        <span if.bind="savedSearch.savingSearch" class="spinner-ring" aria-hidden="true"></span>
        <span>${savedSearch.savingSearch ? 'Saving…' : 'Save'}</span>
      </button>
    </div>
  </form>
</div>
